import { useState, useEffect } from "react";

function useOrientationFullScreen() {
    const getIsLandscape = () => window.matchMedia("(orientation: landscape)").matches;

    const [isLandscape, setIsLandscape] = useState(getIsLandscape);

    useEffect(() => {
        const handleOrientationChange = () => {
            setIsLandscape(getIsLandscape());
        };
        const mediaQuery = window.matchMedia("(orientation: landscape)");
        mediaQuery.addEventListener("change", handleOrientationChange);

        return () => {
            mediaQuery.removeEventListener("change", handleOrientationChange);
        };
    }, []);

    return isLandscape;
}

export default useOrientationFullScreen;
